export default {
  name: "verify-phone-no",
  props: {
    queryState: String
  },

  data() {
    return {
      form: {
        phone_area_code: "852",
        phone: ""
      },
      rules: {
        phone: [{
          required: true,
          message: this.$t("Please fill in only number"),
          pattern: /^[0-9]*$/,
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          this.$emit("submit", this.form);
        }
      });
    }

  }
};